import { mediaQueriesBP } from "@dillon/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasShellContext;

export interface AddToCartContainerStyles {
    gridContainer?: InjectableCss;
}

export const addToCartContainerStyles: AddToCartContainerStyles = {
    gridContainer: {
        css: css`
            ${mediaQueriesBP.maxMD} {
                width: 100%;
                bottom: 0;
                left: 0;
                position: fixed;
                background-color: ${getColor("common.background")};
                z-index: 2;
                padding-inline: 15px;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
                transition: height 0.3s ease-in-out;
            }
        `,
    },
};

const styles = addToCartContainerStyles;

const AddToCartContainer: React.FC<Props> = ({ id, shellContext: { isCurrentPage, isEditing, isInShell } }: Props) => {
    const isShell = isCurrentPage && isInShell;
    const isEdit = isShell && isEditing;

    const [wrapperHeight, setWrapperHeight] = useState(0);
    // Change to 150px
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateHeight = () => {
            if (wrapperRef.current) {
                const screenWidth = window.innerWidth;
                const footer = document.querySelector("footer");
                if (screenWidth < 768 && footer) {
                    const footerRect = footer.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;

                    if (footerRect.top <= viewportHeight) {
                        setWrapperHeight(0);
                    } else {
                        setWrapperHeight(150);
                    }
                }
            }
        };

        window.addEventListener("scroll", updateHeight);

        return () => {
            window.removeEventListener("scroll", updateHeight);
        };
    }, []);

    return (
        <StyledWrapper
            {...(isEdit ? {} : styles.gridContainer)}
            ref={wrapperRef}
            style={{ height: `${wrapperHeight}px` }}
        >
            <Zone contentId={id} zoneName={`Content_${id}`} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(AddToCartContainer),
    definition: {
        displayName: "Add To Cart Container",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
